import { useContext, useEffect } from 'react';

import { MessageContext } from '@/helpers/MessageProvider';
import useParamCommand from '@/hooks/command/mavlink/useParamCommand';
import { useFCTelemetryHandler } from '@/hooks/mavlinkTelemetryHandlers';
import { useAddressSelector } from '@/hooks/useMavLinkAddress';
import useMavLinkCommandHandler from '@/hooks/useMavLinkCommandHandler';
import usePingListener from '@/hooks/usePingListener';
import useWaitingRobot from '@/hooks/useWaitingRobot';
import useWaitingRobotTimer from '@/hooks/useWaitingRobotTimer';
import { executeMavLinkCommand } from '@/utils/CommandUtils';

const useOrganizer = (robot) => {
  const address = useAddressSelector(robot.id);
  const { publishCommand } = useContext(MessageContext);

  const paramCommand = useParamCommand();

  usePingListener(robot.id);
  useWaitingRobotTimer(robot.id);
  const isWaiting = useWaitingRobot(robot.id);

  useFCTelemetryHandler(robot);
  const { addInterval, clearIntervals } = useMavLinkCommandHandler(robot);

  useEffect(() => {
    if (!robot.isActive) return;
    if (!address) return;
    if (isWaiting) return;

    if (robot.isOwned) {
      publishCommand(robot, 'request/autopilot_version', [[...address]]);
    }

    executeMavLinkCommand(robot, paramCommand.set('BATT_MONITOR', 4, 2));

    addInterval('request/heartbeat', [[]], 1000);
    addInterval('request/message_interval', [[...address, 245, 1000000]], 11000); // EXTENDED_SYS_STATE

    return () => {
      clearIntervals();
    };
  }, [robot.isActive, isWaiting, address?.[0], address?.[1]]);
};

export default useOrganizer;
